__turbopack_context__.v({
  "eb_cell": "TableMobile-module-scss-module__3Rl3Tq__eb_cell",
  "section": "TableMobile-module-scss-module__3Rl3Tq__section",
  "table_mobile": "TableMobile-module-scss-module__3Rl3Tq__table_mobile",
  "table_mobile_row": "TableMobile-module-scss-module__3Rl3Tq__table_mobile_row",
});
